import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

export const gt95Hist = new FeatureLayer({
    url: "https://njmaps1.rad.rutgers.edu/arcgis/rest/services/Climate/ZZ_TempGT95/MapServer/12",
    title: 'Number of Days above 95 Historical',
    opacity: 0.4,
    oraId: 'gt95Hist',
  })